import { useState, useEffect } from 'react'
import { get_current_date, ihm_viewer__dictionary, locale } from 'Application/i18n/i18nViewer'

import { PutProjectStatus } from 'Infrastructure/Service/ProjectService'
import { getOrCreateProjectUrl } from 'Infrastructure/Service/UrlService'
import { trackActivity } from 'Infrastructure/Service/AnalyticsService'

import 'Application/Templates/Css/Validation.css'

export const Validation = props => {

    const [ action, setAction ] = useState( null )
    const [ consultUrl, setConsultUrl ] = useState( '#' )
    
    const getCurrentStatus = stat =>
            action ?
                Object.keys(ihm_viewer__dictionary.VALIDATION.STATUSES).includes(stat)?
                    ihm_viewer__dictionary.VALIDATION.STATUSES[stat][locale()]:
                    '-':
                '-'
    
    const setState = action => {
            setAction( action )
            PutProjectStatus( props.project.ref.sk, action )
            trackActivity(action === 'valid' ? 'validate_case' : 'refuse_case')
        }

    useEffect(() => {
        if( props.project.ref.Status.designation !== 'pending' )
            setAction( props.project.ref.Status.designation )
    }, [props])

    useEffect(() => {
        if (props.project?.ref?.sk) {
            getOrCreateProjectUrl(props.project.ref.sk)
                .then(url => setConsultUrl(url))
                .catch(err => {
                    console.error('Failed to load consult URL:', err)
                    setConsultUrl('#')
                })
        }
    }, [props.project?.ref?.sk])

    return (
        <div id="Validation">
            <div>
                <img src={process.env.REACT_APP_U1_VIEWERSVC_APP+'img/logo-C4W.svg'} alt='company Logo' />
                <p>
                    {ihm_viewer__dictionary.VALIDATION.HEADER_LINE[locale()]}<br/>
                    { props.project.ref.creatorUser.fullname }
                </p>
            </div>
            <div id="ConsultSection">
                <span>
                    <a href={consultUrl}>
                        <button id="consultButton">
                        {ihm_viewer__dictionary.VALIDATION.ACTION.CONSULT[locale()]}
                        </button>
                    </a>
                </span>
            </div>
            {
                action === null && props.project.ref.Status.designation === 'pending' ?
                    <div>
                        <span>{ihm_viewer__dictionary.VALIDATION.TRAITMENT_PLAN[locale()]}</span>
                        <span>
                            <button id="validButton" onClick={() => setState('valid')}>{ihm_viewer__dictionary.VALIDATION.ACTION.VALIDATE[locale()]}</button>
                            <button id="refuseButton" onClick={() => setState('refuse')}>{ihm_viewer__dictionary.VALIDATION.ACTION.REFUSE[locale()]}</button>
                        </span>
                    </div>:
                    <div>
                        <span>
                            {ihm_viewer__dictionary.VALIDATION.LAST_ACTION[locale()]}:
                        </span>
                        <span>
                            {
                                props.project.ref.Status.designation === 'pending' ?
                                    action === 'valid'?
                                    <button id="validButton">{ihm_viewer__dictionary.VALIDATION.ACTION.VALIDATE[locale()]}</button>:
                                    <button id="refuseButton">{ihm_viewer__dictionary.VALIDATION.ACTION.REFUSE[locale()]}</button>:
                                <button>{ getCurrentStatus(props.project.ref.Status.designation.toUpperCase()) }</button>
                            }
                        </span>
                    </div>
            }
            <table>
                <tbody>
                    <tr>
                        <td>
                        {ihm_viewer__dictionary.VALIDATION.RECIPIENT[locale()]}:
                        </td>
                        <td>
                            Dr { props.project.ref.doctorUser.fullname +' ( ' + props.project.ref.doctorUser.email +' )'}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {ihm_viewer__dictionary.VALIDATION.CASE_ID[locale()]}:
                        </td>
                        <td>
                            { props.project.ref.designation }
                        </td>
                    </tr>
                    <tr>
                        <td>
                            {ihm_viewer__dictionary.VALIDATION.DELIVERY_DATE[locale()]}:
                        </td>
                        <td>
                            { get_current_date() }
                        </td>
                    </tr>
                </tbody>
            </table>
            <div id='disclamer'>
                {ihm_viewer__dictionary.VALIDATION.NO_REPLY_DISCLAMER[locale()]}
            </div>
        </div>
    )
}
